import { CompetenceSimilaireComponent } from "./CompetenceSimilaire";

export const InfoRoutes = [{
    path: '/info/competencesimilaires',
    element: <CompetenceSimilaireComponent />,
}]